<template>
	<v-container>
		<v-card-actions>
			<v-spacer />
			<action-menu
				entity="item"
				:title="$tc('entities.item.title', 1)"
				:data="value"
			/>
		</v-card-actions>
		<v-tabs v-model="tab" vertical>
			<v-tab key="general">{{ $t("general") }}</v-tab>
			<v-tab key="customfields">{{ $t("customFields") }}</v-tab>
			<v-tab key="version" v-if="value.type == 'Material' || !value.type">{{
				$tc("entities.version.title", 2)
			}}</v-tab>
			<v-tab key="tags" v-if="value.type == 'Material' || !value.type"
				>Tags</v-tab
			>

			<v-tabs-items v-model="tab">
				<v-tab-item key="general">
					<v-form ref="form" v-model="valid">
						<v-text-field
							:label="$t('entities.item.props.code')"
							:rules="$isRequiredRule"
							v-model="value.code"
							clearable
						></v-text-field>
						<v-select
							v-model="value.environmentId"
							:items="environments"
							item-text="description"
							item-value="id"
							:label="$t('entities.item.props.environmentId')"
						></v-select>
						<v-text-field
							:label="$t('entities.item.props.description')"
							:rules="$isRequiredRule"
							v-model="value.description"
							clearable
						></v-text-field>
						<v-select
							:label="$t('entities.item.props.unit')"
							v-model="value.unitId"
							:items="units"
							item-text="description"
							item-value="id"
							clearable
						></v-select>
						<v-select
							:label="$t('entities.item.props.type')"
							v-model="value.type"
							:items="$itemTypes"
							clearable
						></v-select>
					</v-form>
				</v-tab-item>
				<v-tab-item key="customfields" eager>
					<entity-field-custom-autoform
						v-model="value"
						entity="Item"
					></entity-field-custom-autoform>
				</v-tab-item>
				<v-tab-item key="versions" eager>
					<versionFormOffline ref="versionsRef" v-model="value.versions" />
					<!-- <versionFormOnline v-else :itemId="value.id" /> -->
				</v-tab-item>
				<v-tab-item key="tags" eager>
					<div>
						<item-tag-list v-model="value.tags"></item-tag-list>
					</div>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</v-container>
</template>

<script>
	import versionService from "@/services/versionService";
	import environmentService from "@/services/environmentService";
	import versionFormOffline from "@/components/forms/versions/versionFormOffline";
	// import versionFormOnline from "@/components/forms/versions/versionFormOnline";
	import itemTagList from "./itemTagList";
	export default {
		props: {
			value: {
				code: "",
				description: "",
				unitId: "",
				versions: [],
			},
			units: {
				default() {
					return [];
				},
			},
		},
		components: {
			versionFormOffline,

			itemTagList,
		},
		watch: {
			async value() {
				await this.getVersions();
			},
		},
		data() {
			return {
				tab: null,
				valid: false,
				environments: [],
			};
		},
		methods: {
			async getVersions() {
				if (!this.value.id) {
					this.value.versions = [];
					return;
				}
				let res = await versionService.getAll(this.value.id);
				if (res.success) this.value.versions = res.data.data;
				this.$forceUpdate();
			},
			async getEnvironments() {
				let res = await environmentService.getAll();
				if (res.success) this.environments = res.data.data;
				else this.alert.alerts = res.data;
			},
			isValid() {
				if (this.$refs.versionsRef != null) {
					let versionsIsValid = this.$refs.versionsRef.saveChanges();
					if (!versionsIsValid) return false;
				}
				console.log(this.$refs.form);
				return true;

				//return this.$refs.form.validate();
			},
		},
		async mounted() {
			await this.getEnvironments();
			await this.getVersions();
		},
	};
</script>
